import { http } from '@/utils/plugins/http'

// get /api/v1/products/{id}/product_change_logs
// export const getProductChangeLog = (id) => http.get(`/products/${id}/product_change_logs?per_page_count=100`)
export const getProductChangeLog = (objId) => http.get(`/companies/change_logs?object_type=Product&object_id=${objId}&as_owner=true`)
